import { select, put, call, takeLatest } from 'redux-saga/effects';
import * as types from './logSourcesActionTypes';
import LogSourcesApi from '../api/ServiceApi';
import {
    loadLogSourcesFailed,
    loadLogSourcesSuccess
} from './logSourceActions';

export const getOidc = (state) => state.oidc;

function* loadLogSources() {
    try {
        let oidc = yield select(getOidc);
        const response = yield call(LogSourcesApi.getLogSources, oidc.user);
        yield put(loadLogSourcesSuccess(response));
    }
    catch(e) {
        yield put(loadLogSourcesFailed(e.message));
    }
}

export function* loadLogSourcesSaga() {
    yield takeLatest(types.LOAD_LOG_SOURCES, loadLogSources);
}


// WEBPACK FOOTER //
// ./src/log-sources/sagas.js